import { useState, useEffect } from 'react';

import { TYPES, DEFAULT_VALUE } from '../_config/constant';

const useResult = ({
  value,
  defaultValue = DEFAULT_VALUE.value,
  type,
  defaultType = DEFAULT_VALUE.type,
  onCancel,
  onConfirm,
}: any) => {
  const [result, setResult] = useState(value ?? defaultValue);
  const [resultType, setResultType] = useState(type ?? defaultType);

  // 判断传入的 value 是否符合规则
  const isValidValue = (value = {} as any) => {
    const isValid =
      Array.isArray(value?.value) &&
      TYPES.find((item) => item.value === value?.type);
    if (!isValid) {
      console.error('RangeDayMonethSelector 传入的 value 不符合规则');
    }
    return isValid;
  };

  const handleConfirm = (value: any[], type: any) => {
    // 不允许输入负数，-0 为 0
    value = value.map((item: number) => Math.abs(item) + '');
    onConfirm?.({
      value,
      type,
    });
    setResultType(type);
    setResult(value);
  };

  const handleCancel = () => {
    onCancel?.();
  };

  useEffect(() => {
    if (!isValidValue(value)) return;
    setResult(value);
  }, [value]);

  useEffect(() => {
    if (!type && type === resultType) return;
    setResultType(type);
  }, [type]);

  return {
    resultType,
    result,
    handleConfirm,
    handleCancel,
  };
};

export default useResult;
